import ApiUrl from "../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));

const GetSiteMap = async () =>{
    let responce = await  fetch(ApiUrl.API_URL_UserList, {
        method: 'GET'
    });
    responce = responce.json()
    return responce;
}


const UserInfo = ()=>{
    if(User){
        fetch(ApiUrl.API_URL_OAuth+"/info", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
          })
          .then(res=>res.json())
          .then(data =>{
            if(data.success){
                localStorage.setItem("user-info",JSON.stringify(data.responce));
            }
            else{
                localStorage.removeItem('user-info');
                document.location.reload();
            }
        });
    }
}


export default {GetSiteMap,UserInfo}